// ResponsiveSubjectTabs.jsx - モバイル対応科目選択タブ

import React from 'react';
import PropTypes from 'prop-types';
import { SUBJECTS } from '../../../constants';

/**
 * レスポンシブ科目選択タブコンポーネント
 * QuizSubjectTabsのモバイル最適化版
 */
const ResponsiveSubjectTabs = ({
  activeSubject,
  onSubjectSelect,
  enableResponsive = true
}) => {
  
  if (!enableResponsive) {
    // 既存のQuizSubjectTabsと同じレイアウト（完全互換）
    return (
      <div className="flex flex-wrap gap-2">
        {[{ id: 'all', name: '全教科' }, ...SUBJECTS].map((subject) => (
          <button
            key={subject.id}
            onClick={() => onSubjectSelect(subject.id)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
              activeSubject === subject.id
                ? 'bg-purple-500 text-white'
                : 'bg-purple-100 text-purple-700 hover:bg-purple-200'
            }`}
            aria-label={`教科選択ボタン ${subject.name}`}
          >
            {subject.name}
          </button>
        ))}
      </div>
    );
  }

  // レスポンシブ改善版
  return (
    <div className="flex flex-wrap gap-1 sm:gap-2">
      {[{ id: 'all', name: '全教科' }, ...SUBJECTS].map((subject) => (
        <button
          key={subject.id}
          onClick={() => onSubjectSelect(subject.id)}
          className={`
            px-3 sm:px-4 py-2 sm:py-2 rounded-full 
            text-xs sm:text-sm font-medium 
            min-h-[36px] sm:min-h-[32px]
            touch-manipulation
            transition-all duration-200
            ${activeSubject === subject.id
              ? 'bg-purple-500 text-white shadow-md'
              : 'bg-purple-100 text-purple-700 hover:bg-purple-200 active:bg-purple-200'
            }
          `}
          style={{ minWidth: 'max-content' }} // テキストが切れないように確保
          aria-label={`教科選択ボタン ${subject.name}`}
        >
          {subject.name}
        </button>
      ))}
    </div>
  );
};

ResponsiveSubjectTabs.propTypes = {
  activeSubject: PropTypes.string.isRequired,
  onSubjectSelect: PropTypes.func.isRequired,
  enableResponsive: PropTypes.bool
};

export default ResponsiveSubjectTabs; 